<template>
  <div class="content-wrapper">
    <div class="content-heading">
      <div class="pull-right">
        <div class="btn-group">

        </div>
      </div>
      <span>xx</span>
      <small>xxxx</small>
    </div>
    <div class="container-fluid">
      <div>
        <el-form :model="model" :rules="messageRule" ref="message" label-width="120px">

        </el-form>
        <el-button-group>
          <el-button @click="showRejectTask()" type="danger">عدم تایید</el-button>
          <el-button @click="cancel()" type="inverse">انصراف</el-button>
          <el-button @click="doneTask()" type="primary">تایید</el-button>
          <el-button @click="temporaryDoneTask()">ثبت موقت</el-button>
        </el-button-group>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'message',
    props: {
      messageId: {required: true},
    },
    data() {
      return {
        model: {},
        messageRule:{}
      };
    },
    computed: {
    },
    methods: {
    },
    watch: {}
  }
</script>

<style scoped>

</style>
